import React from 'react'
import "./Bbar.css";
function Bbar() {
    return (
        <div>
           <div className="B-bar">
           ©LAVAKUMAR
            </div> 
        </div>
    )
}

export default Bbar
